module.exports = __webpack_public_path__ + "static/media/xleg_normal_left.70e9958d.png";